var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.computedType},on:{"click":_vm.click}},[(_vm.type === 'refresh')?[_c('b-icon',{attrs:{"icon":"arrow-clockwise","aria-label":"Refresh"}}),_vm._t("default")]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }